var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bug"},_vm._l((_vm.pageInfo.pic_url),function(img){return _c('img',{key:img,attrs:{"src":img,"alt":""}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }